var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetSos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 15,
    viewBox: "0 0 26 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_5291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5429 6H9.45728V9H16.5429V6Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 6H18.9143V9H26V6Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45722 12H7.08569V15H9.45722V12Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9433 12H16.5718V15H18.9433V12Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08565 6H0V9H7.08565V6Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2001 12H11.8286V15H14.2001V12Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2001 0H11.8286V3H14.2001V0Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45722 0H7.08569V3H9.45722V0Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9433 0H16.5718V3H18.9433V0Z",
    fill: "#585858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_5291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetSos);
export default __webpack_public_path__ + "static/media/asset-sos.3cbf7fbb5c723b5f18b48c2910f4493f.svg";
export { ForwardRef as ReactComponent };